import { MbPopoverTrigger } from '@am/moebius';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'am-card-filter',
  templateUrl: './card-filter.component.html',
})
export class CardFilterComponent implements OnInit, AfterViewInit {
  @ViewChild(MbPopoverTrigger, { static: true }) public popover: MbPopoverTrigger;

  @Input()
  public type: string;
  @Input()
  public icon: string;
  @Input()
  public showPopover: boolean;
  @Input() public brand: string;
  public image: string;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.image = `${this.brand}-alert.svg`;
  }

  public ngAfterViewInit() {
    this.setPopoverVisibility();
    this.changeDetectorRef.detectChanges();
  }

  private show() {
    this.popover.show();
    setTimeout(() => {
      this.popover.update();
    }, 100);
  }

  private hide() {
    this.popover.hide();
  }

  private setPopoverVisibility() {
    if (this.showPopover) {
      this.show();
      setTimeout(() => {
        this.hide();
      }, 7000);
    }
  }
}
